import { type AxiosRequestConfig } from "axios";
import { HttpService } from "./http-service/http-service";

export module HttpHelper {
  export function postData(url: any, params: any) {
    return new Promise<any>((resolve, reject) => {
      let config = <AxiosRequestConfig>{
        headers: { "Content-Type": "application/json" },
      };

      HttpService.post(url, JSON.stringify(params), config)
        .then((response) => response.data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export function postDataToGetPDF(url: any, params: any) {
    return new Promise<any>((resolve, reject) => {
      let config = <AxiosRequestConfig>{
        headers: { "Content-Type": "application/json" },
        responseType: "blob",
      };

      HttpService.post(url, JSON.stringify(params), config)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "TimeSpentExport.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
          resolve([]);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export function postDataToGetFile(
    url: any,
    params: any,
    invoiceNumber: string,
  ) {
    return new Promise<any>((resolve, reject) => {
      let config = <AxiosRequestConfig>{
        headers: { "Content-Type": "application/json" },
        responseType: "blob",
      };

      HttpService.post(url, JSON.stringify(params), config)
        .then((response: any) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", invoiceNumber + ".pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
          resolve([]);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export function patchData(url: any, params: any) {
    return new Promise<any>((resolve, reject) => {
      let config = <AxiosRequestConfig>{
        headers: { "Content-Type": "application/json" },
      };

      HttpService.patch(url, JSON.stringify(params), config)
        .then((response) => response.data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export function postDataWithAdditionalHeader(
    url: any,
    params: any,
    header: any,
  ) {
    return new Promise<any>((resolve, reject) => {
      let config = <AxiosRequestConfig>{
        headers: { "Content-Type": "application/json" },
      };

      if (header) {
        config.headers[header.name] = header.value;
      }

      HttpService.post(url, JSON.stringify(params), config)
        .then((response) => response.data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export function postBlobData(url: any, params: any) {
    return new Promise<any>((resolve, reject) => {
      let config = <AxiosRequestConfig>{
        headers: { "Content-Type": "multipart/form-data" },
      };

      HttpService.post(url, JSON.stringify(params), config)
        .then((response) => response.data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export function postDataWithHeader(url: any, params: any, config: any) {
    return new Promise<any>((resolve, reject) => {
      HttpService.post(url, JSON.stringify(params), config)
        .then((response) => response.data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export function deleteData(url: any, params: any) {
    return new Promise<any>((resolve, reject) => {
      let config = <AxiosRequestConfig>{
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(params),
      };

      HttpService.delete(url, config)
        .then((response) => response.data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export async function getData<T = any>(url: any, params: any = null) {
    try {
      let response = await HttpService.get<T>(url, <AxiosRequestConfig>{
        data: params,
      });
      return response.data;
    } catch (e: any) {
      if (e && e.message) {
        throw new Error(`Api Url:${url} Error:${e!.message!}`);
      } else {
        throw new Error(`Api Url:${url} Error:${JSON.stringify(e)}`);
      }
    }
  }

  export async function getDataUnsafe<T = any>(url: any, params: any = null) {
    let response = await HttpService.get<T>(url, <AxiosRequestConfig>{
      data: params,
    });
    return response.data;
  }

  export function getDataWithHeader<T = any>(url: any, config: any) {
    return new Promise<any>((resolve, reject) => {
      HttpService.get<T>(url, config)
        .then((response) => response.data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  export function postFormData(url: any, formData: any) {
    return new Promise<any>((resolve, reject) => {
      let config = <AxiosRequestConfig>{
        headers: { "Content-Type": "multipart/form-data" },
      };

      HttpService.post(url, formData, config)
        .then((response) => response.data)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
